<template>
    <div class="generateCode">
        <div class="card">
            <div class="title">{{ $t('share.code.title') }}</div>
            <div class="pic">
                <img :src="base64Image" alt />
            </div>
            <div class="footer">{{$t( 'share.code.expired', { expired })}}
                <span v-if="Number(maxNum) > 0">{{$t( 'share.code.maxNum', { maxNum })}}</span>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data () {

        return {
            url: '',
            maxNum: '',
            expired: '',
            base64Image: ''
        };

    },
    computed: {

        footer () {

            let expired = this.expired;
            let maxNum = this.maxNum;
            return this.$t( 'share.code.footer', {
                expired: expired,
                maxNum: maxNum
            });

        }

    },
    created () {

        this.maxNum = this.$route.query.maxNum;
        // this.expired = this.$route.query.expired;
        this.expired = 30;
        let image = ( this.$route.query.image ).replace( /\s/g, '+' );
        this.base64Image = `data:image/png;base64,${image}`;

    },
    methods: {}
};
</script>
<style lang="less">
.generateCode {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .card {
        width: 6.9rem;
        height: 8.13rem;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        box-shadow: 0 0.12rem 0.22rem rgba(0, 0, 0, 0.2);
        border-radius: 0.26rem;
        .title {
            color: #333;
            font-size: 0.34rem;
            text-align: center;
            padding: 0.38rem 0 0.26rem;
            font-weight: bold;
            border-bottom: 0.01rem solid #e1e1e1;
        }
        .pic {
            padding: 0.2rem;
            img {
                width: 6.5rem;
                height: 6.5rem;
            }
        }
        .footer {
            margin-top: 20px;
            text-align: center;
            font-size: 0.26rem;
            color: #777;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/share/generateCode.vue